module.exports = __webpack_public_path__ + "assets/img/dayu_m_code.494b0a18.png";